import { render, staticRenderFns } from "./WechatReport.vue?vue&type=template&id=bd1cba06&scoped=true"
import script from "./WechatReport.vue?vue&type=script&lang=js"
export * from "./WechatReport.vue?vue&type=script&lang=js"
import style0 from "./WechatReport.vue?vue&type=style&index=0&id=bd1cba06&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1cba06",
  null
  
)

export default component.exports